export const AuthHeaders = (accessToken:any)=>{
    const bearer = `Bearer ${accessToken}`;
   const headers =  new Headers();
   headers.append("Authorization", bearer);
   headers.append("Content-Type","application/json");
  return headers;
}